import Chart from "react-apexcharts";

export default function AreaChart({ categories, series, colors, height = 280 }) {
  const options = {
    chart: { type: "area", toolbar: { show: false }, fontFamily: "Inter, sans-serif", zoom: { enabled: false } },
    colors: colors || ["#7C3AED", "#3B82F6"],
    stroke: { curve: "smooth", width: 2.5 },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.05, stops: [0, 90, 100] },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories,
      labels: { style: { fontSize: "11px", colors: "#64748B" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: { labels: { style: { fontSize: "11px", colors: "#64748B" } } },
    grid: { borderColor: "#E2E8F0", strokeDashArray: 3 },
    legend: { position: "top", horizontalAlign: "right", labels: { colors: "#334155" }, markers: { radius: 4 } },
    tooltip: { theme: "light" },
  };
  return <Chart options={options} series={series} type="area" height={height} />;
}
